import { apiWrapper } from "@/services/api";
import store from "@/store/index";
import mfittService from "@/services/MFITT";

export const getCarNumberVacancyStatus = async (selectedTrainInfo, car_id) => {
  const inputtedInfoOnBooking = store.getters["MFITT/inputtedInfoOnBooking"];
  // 列車の空席情報(空席照会時に入力した乗車日と異なる場合があるので、boarding_dateはこちらを使う)
  const vacancyInquiry = store.getters["MFITT/vacancyInquiry"];

  let response;
  try {
    response = await apiWrapper(
      "GET",
      `/mfitt/car_number_vacancy_status?boarding_date=${mfittService.convertDateFormatForApi(
        vacancyInquiry.boarding_date
      )}&train_number=${selectedTrainInfo.train.train_number}&from_station_id=${
        selectedTrainInfo.from_station.id
      }&to_station_id=${selectedTrainInfo.to_station.id}&special_designation=${
        inputtedInfoOnBooking.special_designation.id
      }&car_id=${car_id}&is_reservated=${inputtedInfoOnBooking.is_reservated}`
    );
    if (response.data.bound == 0) {
      response.data.seats.reverse();
    }
    store.commit("MFITT/setCarNumberVacancyStatus", response.data);
  } catch (err) {
    console.log('ERROR"" getCarNumberVacancyStatus():', err);
    throw err;
  }
  return response.data;
};
